import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Footer from "../components/footer"
// import Lottie from 'react-lottie';
import { Player } from "@lottiefiles/react-lottie-player"
import ServicePageAnimation from "../lottie/Services"
import WebPortalAnimation from "../lottie/web"
import MobileAppAnimation from "../lottie/mobile"
import IllustrationAnimation from "../lottie/illustration"
import BrandingAnimation from "../lottie/branding"
import MotionAnimation from "../lottie/motion"


import Animation from "../components/animation.jsx"
import Transition from "./transition"

export default class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: false,
    }
  }

  componentDidMount() {
    if (!this.state.isMobile) {
      if (window.innerWidth <= 575) {
        this.setState({ isMobile: true })
      }
    }
  }

  footerText = () => {
    return (
      <>
       Did we excite you enough?<br/>If yes, let’s get talking.
      </>
    )
  }

  render() {
    return (
      <Layout hideNavigator>
        <SEO title="Everything you need for your business - branding, apps, websites" pathname={"/services"} />
        <div className="container-fluid home-page">
          <section className="landing-head-section">
            <div className="container">
              <div className=" row align-items-center banner-section">
                <div className="col-md-6 banner-heading">
                  <Transition
                    data={
                      <>
                        <h1 className="heading text-white">
                        From Thought to Finish.<br/>And After.
                        </h1>
                        <p className="text-white pt-3">
                        Our offerings get your idea business-ready. From design, to development, to execution, to upgradation, to continuous maintenance.
                        </p>
                      </>
                    }
                  />
                </div>
                <div className="col-md-6">
                  <Player
                    autoplay
                    loop={true}
                    src={ServicePageAnimation}
                  ></Player>
                </div>
              </div>
            </div>
          </section>

          <section
            className="mt-5"
            style={
              this.state.isMobile
                ? { marginBottom: "10px" }
                : { marginBottom: "48px" }
            }
          >
            <div className="container we-carve-product">
              <div className="row align-items-center justify-content-end carve-product-heading">
                <div className="col-md-6">
                  <Transition
                    data={
                      <>
                        <h1 className="heading">The subsets of our universe</h1>
                      </>
                    }
                  />
                </div>
              </div>
              <div className="row align-items-center carve-product ">
                <div className="col-md-6">
                  <Animation
                    data={WebPortalAnimation}
                    animationHeight="90%"
                    animationWidth="74%"
                  />
                </div>
                <div className="col-md-6">
                  <Transition
                    data={
                      <>
                        <h1 className="heading">Web portals & Apps</h1>
                        <p className="pt-3">
                         Every UX design, every piece of code is thought through
                         and subject to our rigorous process to achieve perfection.
                         To deliver a seamless experience. Every time. Time after time.
                        </p>
                      </>
                    }
                  />
                </div>
              </div>
              <div className="row align-items-center carve-product">
                <div className="col-md-6">
                  <Animation
                    data={MobileAppAnimation}
                    animationHeight="80%"
                    animationWidth="80%"
                  />
                </div>
                <div className="col-md-6">
                  <Transition
                    data={
                      <>
                        <h1 className="heading ">Mobile Apps</h1>
                        <p className="pt-3">
                         The world is already mobile first and Mobile Apps are leading
                         the revolution of changing consumer behaviour. We are helping businesses
                         go Mobile with Apps for tomorrow, today. For the here & now!
                        </p>
                      </>
                    }
                  />
                </div>
              </div>
              <div className="row align-items-center carve-product">
                <div className="col-md-6">
                  <Animation
                    data={BrandingAnimation}
                    animationHeight="80%"
                    animationWidth="85%"
                  />
                </div>
                <div className="col-md-6">
                  <Transition
                    data={
                      <>
                        <h1 className="heading ">Branding</h1>
                        <p className="pt-3">
                         Target Audience Mapping, Consumer Insights, Brand Positioning
                         and Brand Design. We conceive, nurture and build brands.
                        </p>
                      </>
                    }
                  />
                </div>
              </div>
              <div className="row align-items-center carve-product">
                <div className="col-md-6">
                  <Animation
                    data={IllustrationAnimation}
                    animationHeight="80%"
                    animationWidth="80%"
                  />
                </div>
                <div className="col-md-6">
                  <Transition
                    data={
                      <>
                        <h1 className="heading ">Illustration</h1>
                        <p className="pt-3">
                         Illustrations tell stories. Illustrations in every style.
                         Illustrations that match your brand and business.
                        </p>
                      </>
                    }
                  />
                </div>
              </div>

              <div className="row align-items-center carve-product">
                <div className="col-md-6">
                  <Animation
                    data={MotionAnimation}
                    animationHeight="80%"
                    animationWidth="76%"
                  />
                </div>
                <div className="col-md-6">
                  <Transition
                    data={
                      <>
                        <h1 className="heading ">Motion</h1>
                        <p className="pt-3">
                         Life is in constant motion. We bring it to life for your brand and business everyday.
                        </p>
                      </>
                    }
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer contactTitle={this.footerText()} />
        </div>
      </Layout>
    )
  }
}
